const HeadBar = () => {
  return (
    <>
      <div className={"head-bar"}></div>
      <br />
    </>
  );
};

export default HeadBar;
